import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { SharedModule } from "src/app/shared/shared.module";
import { ChartComponent } from "./chart/chart.component";
import { FlatComponent } from "./flat/flat";
import { OverviewComponent } from "./overview/overview";

@NgModule({
    imports: [
        BrowserModule,
        SharedModule,
    ],
    declarations: [
        FlatComponent,
        ChartComponent,
        OverviewComponent,
    ],
    exports: [
        FlatComponent,
        ChartComponent,
        OverviewComponent,
    ],
})
export class Common_Selfconsumption { }
